import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface ReviewEntriesTableWrapperProps {
  oddDocumentRowIds: string[]
}

const getOddDocumentStripeStyle = (oddDocumentRowIds: string[]): string => {
  if (!oddDocumentRowIds.length) {
    return ''
  }

  const oddDocumentRowSelectors = oddDocumentRowIds.map((id) => `li[data-row-id='${id}']`).join(',')

  return `${oddDocumentRowSelectors} {
    background-color: ${Color.Grey50};
  }`
}

/*
 * These selectors reach into design-system Table internals: cells are plain `div` children of
 * their `role="row"` container, `renderAsChildren` wraps custom cells in a further `div`, and
 * sortable headers wrap the label in a `Link`.
 *
 * `flex-shrink` needs `!important` to beat the `flex-shrink: 0 !important` the design system
 * applies to `fixedSize` columns.
 *
 * Overflow stays visible on the inner wrapper so the selection column can paint its checkbox
 * focus ring outside the cell.
 */
export const ReviewEntriesTableWrapper = styled.div<ReviewEntriesTableWrapperProps>`
  width: 100%;
  min-width: 0;

  [role='row'] > div {
    flex-shrink: 1 !important;
    margin-right: ${Spacing.S12};

    &:last-of-type {
      margin-right: 0;
    }

    > div {
      width: 100%;
      min-width: 0;
    }
  }

  [role='columnheader'] > a {
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  ${({ oddDocumentRowIds }) => getOddDocumentStripeStyle(oddDocumentRowIds)}
`
